module.exports = __webpack_public_path__ + "media/Cant Help Falling In Love - Live Session (Desmond Amos ft. DA Entertainment).a98d3b6c.mp3";